var map = {
	"./r1.jpg": 3702,
	"./r2.jpg": 5201,
	"./r3.jpg": 9765,
	"./r4.jpg": 8915,
	"./r5.jpg": 8835,
	"./r6.jpg": 3071,
	"./r7.jpg": 2237,
	"./r8.jpg": 1801,
	"./r9.jpg": 329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2211;